import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { Observable } from 'rxjs/Rx';

import { PortService } from '../../_services/port.service';
import { ProjectService } from '../../_services/project.service';
import { AdminService } from '../../_services/admin.service';
import { FacilityService } from '../../_services/facility.service'

@Component({
    selector: 'app-add-project',
    templateUrl: './add-project.component.html',
    styleUrls: ['./add-project.component.less']
})
export class AddProjectComponent implements OnInit {
    private isNaN: Function = Number.isNaN;
    private isInvalidNumber: Function = (num) => {
        return isNaN(num) || num == null;
    };

    private busy: boolean;
    private years = [];
    private project: any = {};

    private portId: number;
    private slug: string;
    private selectedYear: number;
    private mapType: string;
    private facilityId: number;
    private facilitySlug: string;

    private pmo: any = {};
    private port: any = {};
    private facilities: any = [];
    private facilitiesFlat: any = [];
    private filteredFacilities: any = [];
    private projectTypes: any = [];
    private projectStatuses: any = [{ Id: 0, Title: 'Bidding', }, { Id: 1, Title: 'On-going' }, { Id: 2, Title: 'Completed' }];

    private minDate: Date;
    private maxDate: Date;

    // For navigation projects
    private files: any = [];

    constructor(private router: Router,
        private activatedRoute: ActivatedRoute,
        private portService: PortService,
        private projectService: ProjectService,
        private adminService: AdminService,
        private snackBar: MatSnackBar,
        private facilityService: FacilityService) {

        let params = this.activatedRoute.snapshot.params;
        this.portId = parseInt(params['portId']);
        this.slug = params['slug'];
        this.selectedYear = parseInt(params['year']);
        this.mapType = params['type'];

        this.minDate = new Date(this.selectedYear, 0, 1);
        this.maxDate = new Date(this.selectedYear, 11, 31);
        this.project.Year = this.selectedYear;

        this.project.X = parseFloat(params['x']);
        this.project.Y = parseFloat(params['y']);
    }

    ngOnInit() {
        this.busy = true;
        Observable.forkJoin([
            this.portService.getPmoAndPorts(),
            this.portService.getPort(this.portId, this.selectedYear, this.mapType),
            this.adminService.get('projects/types'),
            this.facilityService.getFacilities(this.portId, this.selectedYear)
        ])
            .subscribe((response) => {
                let pmosAndPortsResponse = response[0];
                let pmosAndPortsResult = pmosAndPortsResponse.json().Result;
                let pmos = pmosAndPortsResult.Offices;

                pmos.some(pmo => {
                    let ports = pmo.Ports;

                    if (ports == null)
                        ports = [];

                    let containsPort = ports.some(port => {
                        if (port.Id == this.portId) {
                            this.port = port;

                            return true;
                        }

                        return false;
                    });

                    if (containsPort) {
                        this.pmo = pmo;
                    }

                    return containsPort;
                });

                let getPortResponse = response[1];
                let getPortResult = getPortResponse.json().Result;
                this.port = { ...this.port, ...getPortResult };

                let getProjectTypesResponse = response[2];
                let getProjectTypesResult = getProjectTypesResponse.json().Result;
                let projectTypes = getProjectTypesResult.ProjectTypes;
                projectTypes.forEach((type) => {
                    if (type.Color == null) type.Color = '#000000';
                    else type.Color = '#' + type.Color;
                });

                this.projectTypes = projectTypes;

                let getFacilitiesResponse = response[3];
                let getFacilitiesResult = getFacilitiesResponse.json().Result;
                this.facilities = getFacilitiesResult.Facilities;
                this._foreachFacility((node) => {
                    this.facilitiesFlat.push({ nest: node.nest, value: node.node });
                });
                this.filteredFacilities = this.facilitiesFlat;

                this.busy = false;
            });

        for (var i = this.selectedYear - 5; i <= this.selectedYear + 5; i++) {
            this.years.push(i);
        }
    }

    getProjectType(id: number) {
        return this.projectTypes.find((type) => type.Id == id);
    }

    getProjectStatus(id: number) {
        return this.projectStatuses.find((status) => status.Id == id);
    }

    filter(val: any) {
        if (val && typeof (val) === 'string') {
            const filterValue = val.toLowerCase();
            return this.facilitiesFlat.filter(state => {
                return state.value.Title.toLowerCase().indexOf(filterValue) !== -1;
            });
        }

        return this.facilitiesFlat;
    }

    displayFacilityName(facility: any): string {
        return facility && typeof (facility) === 'object' ? facility.value.Title : null;
    }

    addProject() {
        this.busy = true;

        let project: any = Object.assign({}, this.project);
        project.PortId = this.port.Id;

        if (this.mapType != 'navigation') {
            project.FacilityId = project.Facility.value.Id;
        }

        if (project.BiddedOn) {
            project.BiddedOn = project.BiddedOn.toISOString();
        }

        if (project.NoticeAwardedOn) {
            project.NoticeAwardedOn = project.NoticeAwardedOn.toISOString();
        }

        if (project.EffectiveOn) {
            project.EffectiveOn = project.EffectiveOn.toISOString();
        }

        if (project.ExpiresOn) {
            project.ExpiresOn = project.ExpiresOn.toISOString();
        }

        if (project.TargetCompletedOn) {
            project.TargetCompletedOn = project.TargetCompletedOn.toISOString();
        }

        if (project.ActualCompletedOn) {
            project.ActualCompletedOn = project.ActualCompletedOn.toISOString();
        }

        delete project.Facility;

        this.projectService.addProject(project).subscribe((response) => {
            this.busy = false;
            let result = response.json().Result;

            if (result.Id) {
                this.snackBar.open('Project was added successfully.', null, { duration: 2000 });
                this.router.navigate(['/', this.portId, this.slug, 'map', this.selectedYear, this.mapType]);
            } else {
                this.snackBar.open('Failed to add project.', null, { duration: 2000 });
            }
        }, (error) => {
            this.busy = false;
            this.snackBar.open('Failed to add project: ' + error.Message, null, { duration: 5000 });
        });
    }

    validateFile($event) {
        let file = this.files.pop();
        this.project.ImagePreview = file;
    }

    private _foreachFacility(callback: Function) {
        let s = [];
        this.facilities.slice().reverse().forEach((node) => {
            s.push({ nest: [], node: node });
        });

        while (s.length > 0) {
            let node = s.pop();
            callback(node);

            if (node.node.Children) {
                node.node.Children.slice().reverse().forEach((child) => {
                    let nest = node.nest.slice();
                    nest.push(node.node.Title);
                    s.push({ nest: nest, node: child });
                });
            } else if (node.node.Facilities) {
                node.node.Facilities.slice().reverse().forEach((child) => {
                    let nest = node.nest.slice();
                    nest.push(node.node.Title);
                    s.push({ nest: nest, node: child });
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./Angular/app/port/add-project/add-project.component.ts